<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms">
      <v-card class="pa-0">
        <v-toolbar card color="white">
          <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="kompetisiSearch"
          hide-details
          ></v-text-field> 
          <v-chip dark v-bind:color="quickcountMode?'warning':'success'">
            <v-switch v-model="quickcountM" v-bind:true-value="true" v-bind:false-value="false" class="mb-1" hide-details              
            ></v-switch> {{quickcountMode ? 'Quickcount':'Realcount'}}
          </v-chip>
          <!--<v-btn icon>
            <v-icon>filter_list</v-icon>
          </v-btn>-->
          <!--<router-link :to="{path: formPath}">
              <v-btn color="success" fab small dark>
                <v-icon>add</v-icon>
              </v-btn>  
          </router-link>-->              
        </v-toolbar>   
        <v-divider></v-divider>
        <v-card-text class="pa-0 branch-scroll nopadding">
          <v-progress-linear color="info" :indeterminate="true" v-if="loading" height="5" class="ma-0"></v-progress-linear>              
          <v-data-table
            :headers="complex.headers"
            :items="complex.items"
            :loading="loading"
            :rows-per-page-items="[-1]"
            class="elevation-1"
            hide-actions      
            hide-headers
            item-key="id"                            
            v-model="complex.selected"
            >
            <template slot="items" slot-scope="props">               
              <tr @click="kompetisiRoute(props.item.id, props.item.tingkat)" style="cursor: pointer;" 
                :class="$route.query.kompetisi_id==props.item.id?'list-select':''" > 
                <td>
                  <v-card>
                    <v-card-text>
                      <div class="layout row ma-0 align-center justify-space-between">
                        
                        <div class="text-box">
                          <v-chip @click="kompetisiRoute(props.item.id, props.item.tingkat)" dark :color="props.item.color"><span class="subheading">{{props.item.name}}</span></v-chip><br/>
                          <span class="grey--text ml-3">{{quickcountMode ? props.item.contain.quick : props.item.contain.done}} <v-icon small :color="props.item.color">trending_up</v-icon> {{props.item.contain.all}} TPS</span>
                        </div>
                        <div class="chart">
                          <v-progress-circular
                            :size="60"
                            :width="5"
                            :rotate="360"
                            :value="persenContain(props.item.contain)"
                            :color="quickcountMode ?'warning':'success'"
                          >
                          {{persenContain(props.item.contain)}}%
                          </v-progress-circular>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>  
                </td>
                
                <!--<td><v-chip v-bind:color="props.item.color" dark>
                  <v-avatar class="grey">{{firstLetter(props.item.modeName )}}</v-avatar>{{ props.item.name }}</v-chip>                
                </td>-->
              </tr>
            </template>
          </v-data-table>
          <v-flex xs12 class="pa-3" v-if="complex.items.length < complex.count">
            <v-btn block color="info" :loading="loading" small dark @click="init()">load more ...</v-btn>
          </v-flex>
        </v-card-text>
      </v-card>        
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/frc/models/Hitung';   
import MiniChart from '@/components/widgets/chart/MiniChart';
import Material from 'vuetify/es5/util/colors';

var model = new Model();

export default {
    components:{
      MiniChart,
    },
    $_veeValidate: {
      validator: 'new'
    },    
    props:{    
      quickcountMode : {
        type: Boolean,
        default: false,
      },    
    },  
    data: () => ({        
        color: Material,      
        formPath : '/kompetisi/form',
        search   : '',
        loading  : true,
        pagination: {},
        kompetisiSearch:null, 
        quickcountM : false,
        complex  : {
            selected: [],
            headers: [              
              { text: 'Kompetisi', value: 'name', align:'center', sortable:false}
            ],
            items: [],
            count:0,
            page:1,
        },
    }),  
    watch:{
      kompetisiSearch(newVal){
        const ctx = this; setTimeout(function(){
          if(newVal===ctx.kompetisiSearch){
            ctx.init(true);
          }
        },700);
      },
      quickcountM(newVal){
        this.$emit('update:quickcountMode', newVal);
      },
      quickcountMode(newVal){
        if(this.quickcountM !== newVal)
          this.quickcountM = newVal;
      }
    },
    mounted(){ this.init() },        
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.complex.items = data }) },{ deep: true }
            );                                     
        }
    },
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        init(reset = false){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }
            this.loading = true;
            if(reset) this.complex.page = 1;
            model.kompetisis({'KompetisiSearch[name]':this.kompetisiSearch, page:this.complex.page}).then(res => {      
                if(res.status !== 200) return;
                if(reset) {this.complex.items = [];}                
                this.complex.items = [...this.complex.items, ...res.data.data]; 
                this.complex.page++; 
                this.complex.count = res.data.count;
                if(reset && this.complex.items.length === 0) {this.complex.page = 1;}
                this.loading = false;
            });                                         
        },
        
        persenContain(contain){
            return this.quickcountMode ? (contain.quick/contain.all*100).toFixed(1) : (contain.done/contain.all*100).toFixed(1);
        },
        
        firstLetter (name) {
            return name.charAt(0);
        },
        
        areaRoute (id, tingkat) {
            let area_ids = this.$route.query.area_ids;
            let tingkat_ids = this.$route.query.tingkat_ids;
            this.$router.push({path:'/hitung', query: {
                kompetisi_id: id, tingkat: tingkat,
                area_ids:area_ids, tingkat_ids:tingkat_ids
            }});
        },
        
        kompetisiRoute (id, tingkat) {
            let area_ids = this.$route.query.area_ids;
            let tingkat_ids = this.$route.query.tingkat_ids;
            this.$router.push({path:'/hitung', query: {
                kompetisi_id: id, tingkat: tingkat,               
            }});
        },
    }
}
</script>
  
